/**
 * Cta — a closing call-to-action band: title, optional subtitle, and a primary
 * button. Composes Card (tinted) + Button + MarketingLink. Tokens only.
 */
import type { ReactNode } from 'react';
import { Card } from '../card';
import { Button } from '../button';
import { MarketingLink } from '../marketing-link';

export interface CtaProps {
  readonly title: ReactNode;
  readonly subtitle?: ReactNode;
  readonly ctaLabel: string;
  readonly ctaHref: string;
  readonly secondaryLabel?: string;
  readonly secondaryHref?: string;
}

export function Cta({ title, subtitle, ctaLabel, ctaHref, secondaryLabel, secondaryHref }: CtaProps) {
  return (
    <Card className="bg-primary-light p-(--space-card-lg) text-center">
      <h2 className="font-display text-3xl font-bold tracking-tight text-foreground sm:text-4xl">{title}</h2>
      {subtitle && <p className="mx-auto mt-4 max-w-xl text-lg text-muted-foreground">{subtitle}</p>}
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Button asChild size="lg">
          <MarketingLink href={ctaHref}>{ctaLabel}</MarketingLink>
        </Button>
        {secondaryLabel && secondaryHref && (
          <Button asChild size="lg" variant="outline">
            <MarketingLink href={secondaryHref}>{secondaryLabel}</MarketingLink>
          </Button>
        )}
      </div>
    </Card>
  );
}
